import { Currency, CurrencySymbols } from '../enums';
import { CurrencyMeta } from './types';

export const CurrencyMetaMap: Record<Currency, CurrencyMeta> = {
	[Currency.USD]: { symbol: CurrencySymbols.USD, position: 'before' },

	[Currency.RUB]: { symbol: CurrencySymbols.RUB, position: 'after' },
	[Currency.EUR]: { symbol: CurrencySymbols.EUR, position: 'after' },
	[Currency.SAR]: { symbol: CurrencySymbols.SAR, position: 'after' },
	[Currency.AED]: { symbol: CurrencySymbols.AED, position: 'after' },
	[Currency.AMD]: { symbol: CurrencySymbols.AMD, position: 'after' },
	[Currency.UZS]: { symbol: CurrencySymbols.UZS, position: 'after' },
	[Currency.AZN]: { symbol: CurrencySymbols.AZN, position: 'after' },
	[Currency.TRY]: { symbol: CurrencySymbols.TRY, position: 'after' },
	[Currency.RSD]: { symbol: CurrencySymbols.RSD, position: 'after' },
	[Currency.GEL]: { symbol: CurrencySymbols.GEL, position: 'after' },
	[Currency.ILS]: { symbol: CurrencySymbols.ILS, position: 'after' },
	[Currency.KZT]: { symbol: CurrencySymbols.KZT, position: 'after' },
	[Currency.CNY]: { symbol: CurrencySymbols.CNY, position: 'after' },
	[Currency.BYN]: { symbol: CurrencySymbols.BYN, position: 'after' },
	[Currency.TJS]: { symbol: CurrencySymbols.TJS, position: 'after' },
	[Currency.GBP]: { symbol: CurrencySymbols.GBP, position: 'after' }
};
